import CryptoJS from "crypto-js";

export const hashParams = (params) => {
  const paramsString = JSON.stringify(params);
  return CryptoJS.MD5(paramsString).toString();
};



export const createQueryParams = (params) => {
    const queryParams = new URLSearchParams();
    Object.entries(params).forEach(([key, value]) => {
        if (Array.isArray(value)) {
          queryParams.append(key, value.join(','));
        } else if (value !== null && value !== undefined){
        queryParams.append(key, value);
        }
    });
    return queryParams.toString();

}
// Error handling helper function
export const handleError = (error, rejectWithValue) => {
  return rejectWithValue(error.message);
};



export function createRequestKey(endpointName, args) {
  // Convert args to a JSON string, or do a custom concatenation
  // to keep it short. Below is a simple approach:
  const argsStr = JSON.stringify(args);

  // Construct the key (you can do anything you want here):
  return `${endpointName}::${argsStr}`;
}

